//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentClassificationSelect from "@Broker/@Modules/clients/applications/documents/components/utils-components/document-classification-select.vue";
import * as DocumentsGetters from "../../../../../clients/applications/documents/store/documents-getters";
import { defineComponent, reactive, ref } from "@vue/composition-api";
import { useDocumentsStoreGetters, useDocumentsStoreState } from "@Broker/@Modules/clients/applications/documents/store/document-helpers";
export default defineComponent({
  name: "DocumentClassificationSelectContainer",
  components: {
    DocumentClassificationSelect
  },
  props: {
    parentId: {
      type: String,
      default: "classification-select-container"
    },
    id: {
      type: String,
      default: "classification-select"
    }
  },
  setup(props, {
    emit
  }) {
    const creating = ref(false);
    const value = reactive({
      id: "",
      documentType: ""
    });
    const {
      DOCUMENT_TYPES_SELECT,
      DOCUMENT_TYPE_DESCRIPTION
    } = useDocumentsStoreGetters([DocumentsGetters.DOCUMENT_TYPES_SELECT, DocumentsGetters.DOCUMENT_TYPE_DESCRIPTION]);
    const {
      documentTypes
    } = useDocumentsStoreState(["documentTypes"]);
    const handleClassificationSelection = async ({
      documentType,
      id
    }) => {
      const description = id === "no-results-btn" ? "" : DOCUMENT_TYPE_DESCRIPTION.value(id);
      emit("create", {
        id,
        classification: documentType,
        description
      });
    };
    return {
      creating,
      value,
      DOCUMENT_TYPES_SELECT,
      documentTypes,
      handleClassificationSelection
    };
  }
});